module.exports = __webpack_public_path__ + "ecd94901e5fc9a1eb90e2386425c7fc6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IE.svg
// module id = 2zgw
// module chunks = 0